import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./SmartContainerSolutions.css";
import trackingIcon from "../../imgs/container/tracking.png"; // Example icon
import alertIcon from "../../imgs/container/alert.png"; // Example icon
import sensorIcon from "../../imgs/container/sensor.png"; // Example icon
import containerImage from "../../imgs/container/containerBgImg.jpg"; // Example background image
import { Context } from "../LocalWrapper";

const SmartContainerSolutions = () => {
  const context = useContext(Context);
  const { t } = useTranslation();

  const featuresIcon = {
    trackingIcon: trackingIcon,
    alertIcon: alertIcon,
    sensorIcon: sensorIcon,
  };

  const features = t("container_solutions.features", { returnObjects: true });

  const benefits = t("container_solutions.benefits", { returnObjects: true });

  return (
    <div
      className="smart-container-section"
      style={{ backgroundImage: `url(${containerImage})` }}
      dir={context.dir}
    >
      <h2 className="title oz-title">{t("container_solutions.title")}</h2>
      <p className="subtitle oz-subtitle">
        {t("container_solutions.subtitle")}
      </p>

      <div className="features">
        {Object?.entries(features).map(([key, feature]) => (
          <div key={key} className="feature-card">
            <img
              src={featuresIcon[feature.icon]}
              alt={feature.title}
              className="feature-icon"
            />
            <h3 className="feature-title oz-paragraph">{feature.title}</h3>
            <p className="feature-description oz-paragraph">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      <div className="benefits">
        <h3 className="benefits oz-subtitle">
          {t("container_solutions.benefitsTitle")}
        </h3>
        <ul>
          {benefits.map((benefit, index) => (
            <li key={index} className="benefit-item oz-paragraph">
              {benefit}
            </li>
          ))}
        </ul>
      </div>

      {/* <div className="cta-section">
        <p className="cta">{t("cta")}</p>
        <button className="cta-button">{t("button")}</button>
      </div> */}
    </div>
  );
};

export default SmartContainerSolutions;
